// field type -> component. Every component takes the same props (see Group.js, which builds them):
// field, id, path, value, on_change, on_error, error (text), required, disabled, styles, class_names, lang, messages,
// plus form_values and custom_fields for custom fields, geo / state_value / all_cities for state and city.
import { CUSTOM_FIELD_PREFIX } from "../form_helper.js";
import { TextualField } from "./textual.js";
import { SelectField, MultiSelectField, ChoiceGroupField } from "./options.js";
import { DateField } from "./date.js";
import { FileField } from "./file.js";
import { GeoField } from "./geo.js";
import { CustomField } from "./custom.js";

export const FIELD_COMPONENTS = Object.freeze({
    text: TextualField,
    textarea: TextualField,
    number: TextualField,
    price: TextualField,
    mobile: TextualField,
    email: TextualField,
    national_code: TextualField,
    postal_code: TextualField,
    select: SelectField,
    multi_select: MultiSelectField,
    radio: ChoiceGroupField,
    checkbox: ChoiceGroupField,
    toggle: ChoiceGroupField,
    date: DateField,
    file: FileField,
    state: GeoField,
    city: GeoField,
});

export const field_component = (type) => {
    if (typeof type === "string" && type.startsWith(CUSTOM_FIELD_PREFIX)) {
        return CustomField;
    }
    return FIELD_COMPONENTS[type] || null;
};
